import { VulnerabilityItem } from '@internal/schemas-common';

type GetVulnerabilitiesProps = {
  baseUrl: string;
  token: string;
  teamName: string;
};

export async function getVulnerabilities({
  baseUrl,
  token,
  teamName,
}: GetVulnerabilitiesProps): Promise<VulnerabilityItem[]> {
  if (!baseUrl || !token || !teamName) {
    throw new Error(
      'zf-vulnerabilities plugin base URL or team name not available',
    );
  }
  const fetchUrl = new URL(`${baseUrl}/vulnerabilities`);
  fetchUrl.search = new URLSearchParams({
    teamName,
  }).toString();

  const response = await fetch(fetchUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error ${response.status}`);
  }
  const res = (await response.json()) as { data: VulnerabilityItem[] };

  return res.data;
}
